import React from 'react'
import MobileLogo from '../assets/FooterMobile.svg'
import QrLogo from '../assets/FooterQR.svg'
import { MdOutlineMail , MdOutlinePhone} from "react-icons/md";
import { HiOutlineLocationMarker } from "react-icons/hi";
import {useNavigate,useLocation} from 'react-router-dom'
import FooterGlobe from '../assets/Footer_globe.svg'
import FooterInsta from '../assets/Footer_insta.svg'
import FooterLinkedin from '../assets/Footer_linkedin.svg'
function NewFooter() {
    const navigate=useNavigate();
    const location=useLocation();
    const handleFooterNav = (path) => {
      if (location.pathname === path) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate(path);
      }
    };
  return (
    <>
<footer className="bg-[#FFFFFF] text-gray-800 px-12 py-10 shadow-inner w-full rounded-2xl mx-auto mt-6">
  <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-start gap-[60px]">
    <div className="flex justify-center lg:justify-start self-center sm:items-start">
      <img
        src={MobileLogo}
        alt="Graviton Mobile"
        className="h-[280px] w-[133px] object-contain"
      />
    </div>
    <div className="flex flex-wrap gap-[40px] max-w-[1150px] items-start text-[13px] font-[400] sm:grid sm:grid-cols-1 md:grid md:grid-cols-2 lg:grid lg:grid-cols-4">
      <div className="space-y-[24px] max-w-[400px]">
        <div className="space-y-[12px]">
          <h3 className="text-[#204887] text-[18px] font-[600]">Graviton on the go!</h3>
          <p>Download the Graviton app for Android to manage your loans from anywhere, anytime!</p>
        </div>
        <div className='flex gap-[5px]'>
        <img
          src={QrLogo}
          alt="QR Code"
          className="h-[80px] w-[80px]"
        />
          </div>
      </div>
      <div className="space-y-[12px] min-w-[120px]">
        <h3 className="text-[#204887] text-[18px] font-[600]">Company</h3>
        <div className="flex flex-col gap-[8px]">
          <a href="https://www.kugelblitz.xyz/about-us" className="hover:text-[#204887]" target='_blank' rel="noopener noreferrer">About Us</a>
          <a href="https://www.kugelblitz.xyz/our-story" className="hover:text-[#204887]" target='_blank' rel="noopener noreferrer">Our Story</a>
          <a href="https://www.kugelblitz.xyz/legal" className="hover:text-[#204887]" target='_blank' rel="noopener noreferrer">Legal</a>
          <a href="https://www.kugelblitz.xyz/terms-conditions" className="hover:text-[#204887]" target='_blank' rel="noopener noreferrer">Terms & Conditions</a>
          <a href="https://www.kugelblitz.xyz/copy-of-terms-conditions" className='hover:text-[#204887]' target='_blank' rel='noopener noreferrer'>Refund Policy</a>
        </div>
      </div>
      <div className='space-y-[12px] min-w-[140px]'>
      <div>
    <h3 className="text-[#204887] text-[18px] font-[600]">Help & Support</h3>
    <div className="flex flex-col gap-[8px] mt-[10px]">
      <a href="#" className="hover:text-[#204887]">Knowledge Base</a>
      <a href="#" className="hover:text-[#204887]">Help Document</a>
    </div>
  </div>
  <div className='!mt-[40px]'>
    <h3 className='text-[#204887] text-[18px] font-[600]'>Quick Links</h3>
    <div className='flex flex-col gap-[8px] mt-[10px]'>
      <span
        onClick={() => handleFooterNav('/')}
        className='cursor-pointer hover:text-[#204887]'
      >
        Dashboard
      </span>
      <span
        onClick={() => handleFooterNav('/currentplan')}
        className='cursor-pointer hover:text-[#204887]'
      >
        Plans & Pricing
      </span>
    </div>
  </div>
</div>

  <div className="space-y-[12px] max-w-[320px]">
  <h3 className="text-[#204887] text-[18px] font-[600]">Contact</h3>
  <div className="flex flex-col gap-[8px] text-[14px] font-[400]">
    

        <div className="flex items-center justify-start gap-2">
        <MdOutlineMail className="mt-[2px]" size={20} />
        <a
          href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=neeraj@kugelblitz.xyz&tf=1"

          className="hover:text-[#204887]"
          target="_blank"
          rel="noopener noreferrer"
        >
          neeraj@kugelblitz.xyz
        </a>
      </div>
     <div className="flex items-center justify-start gap-2">
     <MdOutlinePhone  className="mt-[2px]" size={20} />
      <a href="#" className="hover:text-[#204887]">+91 89553 74341</a>
     </div>
     <div className="flex items-start justify-start gap-2">
     <div className="custom-icon" >
     <HiOutlineLocationMarker size={20} className="custom-icon" />
      </div>
      <a
        href="https://www.google.com/maps/search/?api=1&query=1st+Floor,+40,+Shiv+Vatika+A,+Ganpatpura,+Mangyawas,+Mansarovar,+Jaipur,+Rajasthan+302020"
        target="_blank" rel="noopener noreferrer" className="hover:text-[#204887]">
        Head Office:- 1st Floor, 40, Shiv Vatika A, Ganpatpura, Mangyawas, Mansarovar, Jaipur, Rajasthan 302020
        </a>
     </div>
     <div className="flex items-start justify-start gap-2">
     <div className="custom-icon" >
     <HiOutlineLocationMarker size={20} className="custom-icon" />
      </div>
      <a
        href="https://www.google.com/maps/search/?api=1&query=B-091,+Commander's+glory,+Singhapura,+Vidyaranyapura,+Bangalore+560097"
        target="_blank" rel="noopener noreferrer" className="hover:text-[#204887]">
        Corporate Office:- B-091, Commander's glory, Singhapura, Vidyaranyapura Bangalore 560097
        </a>
     </div>
  </div>
</div>
    </div>
  </div>
  <div className="w-full px-5 mt-10">
  <div className="w-full h-[1px] bg-[#204887]" />
  <div className="mt-3 flex items-center justify-between text-[#204887] text-sm font-normal">
    <span className='text-[14px]'>
      Graviton Copyright © 2025 Kugelblitz Private Limited (CIN:U72900KA2021PTC148813)
    </span>
    <div className="flex items-center gap-3">
      <a href="https://www.kugelblitz.xyz/" target='_blank' rel="noopener noreferrer">
        <img src={FooterGlobe} alt="Footer_Globe" className="h-10 w-10" />
      </a>
      <a href="https://www.instagram.com/kugelblitz.pvt/" target='_blank' rel="noopener noreferrer">
        <img src={FooterInsta} alt="Footer_Insta" className="h-10 w-10" />
      </a>
      <a href="https://www.linkedin.com/company/kugelblitz/posts/?feedView=all" target='_blank' rel="noopener noreferrer">
        <img src={FooterLinkedin} alt="Footer_Linkedin" className="h-10 w-10" />
      </a>
    </div>
  </div>
</div>
</footer>
    </>
  )
}

export default NewFooter
